import { useQuery } from 'react-query';
import { getZones } from '../services';
import { queryKeys } from '../services/queryKeys';

// The zone list of one system ('ess' | 'tgs' | 'tes'). Boot fetches it once;
// every page reads the same cache entry, so a refetch (Settings does one
// after a save) refreshes them all.
export const useZonesQuery = (system, { enabled = true } = {}) =>
  useQuery(
    queryKeys.zones(system),
    () => getZones(system, { structured: true }),
    { enabled, staleTime: Infinity },
  );
